import React from 'react';

/**
 * Reusable Autocomplete Dropdown Component
 * @param {Object} props
 * @param {Array} props.suggestions - Array of suggestion items
 * @param {boolean} props.showDropdown - Whether to show dropdown
 * @param {boolean} props.isLoading - Loading state
 * @param {Function} props.onSelect - Callback when item is selected
 * @param {Function} props.getValue - Function to extract display value from item
 * @param {Function} props.getKey - Function to extract key from item
 * @param {Object} props.dropdownRef - Ref for dropdown element
 * @param {string} props.placeholder - Loading placeholder text (default: "Loading...")
 * @returns {JSX.Element|null}
 */
const AutocompleteDropdown = ({
  suggestions,
  showDropdown,
  isLoading,
  onSelect,
  getValue,
  getKey,
  dropdownRef,
  placeholder = "Loading..."
}) => {
  if (!showDropdown || (!suggestions.length && !isLoading)) {
    return null;
  }

  return (
    <div 
      ref={dropdownRef}
      className="autocomplete-dropdown"
      style={{
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        border: '1px solid #ddd',
        borderRadius: '4px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        zIndex: 1000,
        maxHeight: '200px',
        overflowY: 'auto',
        marginTop: '4px'
      }}
    >
      {isLoading ? (
        <div style={{ padding: '12px', textAlign: 'center', color: '#666' }}>
          {placeholder}
        </div>
      ) : (
        suggestions.map((item, index) => (
          <div
            key={getKey ? getKey(item, index) : index}
            onClick={() => onSelect(item)}
            style={{
              padding: '12px 16px',
              cursor: 'pointer',
              borderBottom: index < suggestions.length - 1 ? '1px solid #eee' : 'none',
              transition: 'background-color 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#f5f5f5';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#fff';
            }}
          >
            {getValue ? getValue(item) : item}
          </div>
        ))
      )}
    </div>
  );
};

export default AutocompleteDropdown;

